import React from "react";

interface Props {
  title: string;
  /** The common right-column case: a styled description paragraph. */
  description?: string;
  /** Escape hatch for custom right-column content. Ignored if `description` is set. */
  right?: React.ReactNode;
  accentClass?: string;
  className?: string;
  id?: string;
}

const SectionHeader: React.FC<Props> = ({
  title,
  description,
  right,
  accentClass = "bg-accent",
  className = "",
  id,
}) => {
  return (
    <div
      id={id}
      className={
        "mb-8 grid gap-3 border-y border-border py-5 md:grid-cols-[0.8fr_1.2fr] md:items-center " +
        className
      }
    >
      <div className="flex items-center gap-3">
        <span className={`h-2 w-2 rounded-full ${accentClass}`} />
        <h2 className="text-xs font-mono tracking-[0.12em] uppercase text-text-muted">
          {title}
        </h2>
      </div>

      <div>
        {description !== undefined ? (
          <p className="text-sm leading-relaxed text-text-secondary md:text-right">
            {description}
          </p>
        ) : (
          right
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
